import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { I18n, Link, Status } from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const XbrStatus = ({ loginUrl }) => (
  <Status
    className={['attention', cx('container')]}
    emoji="statusFail"
  >
    <Link href={loginUrl}>
      <I18n path="home.xbrStatus.authorize" />
    </Link>
    , &nbsp;
    <I18n path="home.xbrStatus.toFullAccess" />
  </Status>
);

XbrStatus.propTypes = {
  loginUrl: PropTypes.string,
};

export default XbrStatus;
